import { useState, useEffect } from "react";
import styles from "./Header.module.scss";
import { FaBars } from "react-icons/fa";
import sidebar from "../../constants/sidebar.constant";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import sidebar_icons from "../../constants/sideBarIcons";
import sidebar_url_icons from "../../constants/sideBarUrlsIcons";
import { eraseCookie, getCookie } from "../../utils/utils";
import { adminLogout } from "../../services/auth.service";
import bionetlogo from "../../assets/images/bionet-logo/bionetlogo.png";
import MainButton from "../../components/shared/MainButton/MainButton";
import Footer from "../footer/Footer";
import { Modal } from "antd";

const Header = () => {
  const [urlsTab, setUrlsTab] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDashboard, setActiveDashboard] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const [logoutModal, setLogoutModal] = useState(false);
  const [urls, setUrls] = useState<any[]>(
    sidebar.length > 0 ? sidebar[0].items : []
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const location = useLocation();

  const navigate = useNavigate();

  const handleNavigate = (index: number, items: any[]) => {
    const currentPath = location.pathname.replace("/admin/", "");

    const foundUrl = items
      .flatMap((item) => item.urls)
      .find(
        (url) =>
          currentPath === url.url_path ||
          currentPath.startsWith(`${url.url_path}/`)
      );

    if (!foundUrl) {
      const firstPath = items[0].urls[0].url_path;
      navigate(`/admin/${firstPath}`);
    }

    setActiveIndex(index);
    setUrls(items);
    setUrlsTab(true);
    setActiveDashboard(false);
  };

  const handleTabs = () => {
    setUrlsTab((prev) => !prev);
    setActiveDashboard((prev) => !prev);
    setIsSidebarOpen(true);
    if (window.innerWidth <= 1024) {
      setUrlsTab(true);
    }
  };

  const handleLogout = () => {
    adminLogout().then((response) => {
      if (response.status === 200) {
        eraseCookie("BscAdminToken");
        const token = getCookie("BscAdminToken");
        !token && navigate("/login");
      }
    });
  };

  const handleResize = () => {
    if (window.innerWidth <= 1024) {
      setIsSidebarOpen(false);
    }
  };

  const findIconByUrl = (urlPath: string) => {
    return sidebar_url_icons.find((icon) => icon.url_path === urlPath) || null;
  };
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (sidebar.length > 0) {
      const currentPath =
        location.pathname.replace("/admin/", "") ||
        sidebar[0].items[0].urls[0].url_path;

      sidebar.forEach((element: any, index: number) => {
        element.items.forEach((item: any) => {
          if (
            item.urls.some(
              (url: any) =>
                currentPath === url.url_path ||
                currentPath.startsWith(`${url.url_path}/`)
            )
          ) {
            setActiveIndex(index);
            setUrls(element.items);
          }
        });
      });
    }
  }, [location.pathname]);

  useEffect(() => {
    if (sidebar.length > 0 && location.pathname === "/admin") {
      const defaultPath = sidebar[0].items[0].urls[0].url_path;
      navigate(`/admin/${defaultPath}`);
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div id={styles.header_sidebar}>
      <header id={styles.header}>
        <div
          className={`${styles.header} ${isScrolled ? styles.scrolled : ""}`}
        >
          <div className="container">
            <div className={styles.header_content}>
              <div className={styles.header_left}>
                <FaBars
                  onClick={() => handleTabs()}
                  color="rgb(3, 169, 244)"
                  size={"20px"}
                  cursor={"pointer"}
                />
                <div className={styles.logo}>
                  <img src={bionetlogo} alt="bionet" />
                </div>
              </div>
              <div className={styles.header_right}>
                <div className={styles.login_side}>
                  <MainButton onClick={() => setLogoutModal(true)}>
                    Çıxış
                  </MainButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div>
        {isSidebarOpen && (
          <div
            onClick={() => setIsSidebarOpen(false)}
            className={styles.sidebar_background}
          ></div>
        )}
        <div
          className={`${styles.sidebar} ${
            isSidebarOpen ? styles.sidebar_open : ""
          }`}
        >
          <div className={styles.sidebar_logo}>
            <img src={bionetlogo} alt="bionet" />
          </div>
          <div className={styles.sidebar_content}>
            <div className={styles.sidebar_icon_title}>
              {sidebar.map((element: any, index: number) => {
                const icon = sidebar_icons[index];
                const isActive = activeIndex === index;
                return (
                  <div
                    key={index}
                    onClick={() => handleNavigate(index, element.items)}
                    className={`${styles.icon_title_box} ${
                      isActive ? styles.box_active : ""
                    }`}
                  >
                    <div className={styles.sidebar_icon}>
                      {icon && (
                        <img
                          width={"30px"}
                          src={isActive ? icon.active_icon : icon.icon}
                          alt={"counter icon"}
                        />
                      )}
                    </div>
                    <p>{element.sidebar_title}</p>
                  </div>
                );
              })}
            </div>
            <div
              className={`${styles.urls_tab} ${
                urlsTab ? styles.active_tab : ""
              }`}
            >
              {urls?.map((el: any, idx: number) => {
                return (
                  <div key={String(idx)} className={styles.title_urls_box}>
                    <h3 className={styles.urls_title}> {el.urls_title}</h3>
                    <div className={styles.urls}>
                      {el.urls.map((e: any, i: number) => {
                        const isActiveUrl =
                          location.pathname === `/admin/${e.url_path}`;
                        const icon = findIconByUrl(e.url_path);

                        return (
                          <Link
                            to={`${`/admin/${e.url_path}`}`}
                            onClick={() => setIsSidebarOpen(false)}
                            key={i}
                            className={`${styles.url} ${
                              isActiveUrl ? styles.active_url : ""
                            }`}
                          >
                            <div className={styles.url_link}>
                              {icon && (
                                <img
                                  width={"18px"}
                                  src={
                                    isActiveUrl ? icon.active_icon : icon.icon
                                  }
                                  alt={`${e.url_name} icon`}
                                />
                              )}
                              <p> {e.url_name}</p>
                            </div>
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div
          className={`${styles.dashboard} ${
            activeDashboard ? styles.active_dashboard : ""
          }`}
        >
          <Outlet />
          <Footer />
        </div>
      </div>
      <Modal
        centered
        open={logoutModal}
        okText="Çıxış"
        cancelText="Ləğv et"
        onOk={handleLogout}
        onCancel={() => setLogoutModal(false)}
      >
        <div className={styles.logoutModal}>
          <p>Hesabdan çıxmaq istəyirsiz?</p>
        </div>
      </Modal>
    </div>
  );
};

export default Header;
